import { render } from "./Otros.vue?vue&type=template&id=2cb265b0&scoped=true"
import script from "./Otros.vue?vue&type=script&lang=js"
export * from "./Otros.vue?vue&type=script&lang=js"

import "./Otros.vue?vue&type=style&index=0&id=2cb265b0&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/boletiland/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb265b0"]])

export default __exports__